import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../services';
import { UserType } from '@app/models';

@Injectable({ providedIn: 'root' })
export class MerchandisingGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.accountService.userValue;

        // Verificar si el usuario está logueado
        if (!this.accountService.isLoggedIn() || !user) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        // Permitir acceso a administradores (DoItYourself)
        if (user.user_type === UserType.DoItYourself) {
            return true;
        }

        // Permitir acceso a usuarios de merchandising
        if (user.user_type === UserType.Merchandising) {
            return true;
        }

        // Denegar acceso a otros tipos de usuario y redirigir a configuración
        this.router.navigate(['/settings']);
        return false;
    }
}
